import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownTimerProps {
  variant?: 'dark' | 'light';
  className?: string;
}
export function CountdownTimer({
  variant = 'dark',
  className = ''
}: CountdownTimerProps) {
  const {
    minutes,
    seconds
  } = useCountdown();
  const isDark = variant === 'dark';
  const badgeClass = isDark ? 'bg-red-600 text-white border border-red-500' : 'bg-white/20 text-white border border-white/30 backdrop-blur-sm';
  const separatorClass = isDark ? 'text-red-600' : 'text-white/80';
  return <div className={`flex items-center justify-center space-x-2 font-mono font-bold ${className}`} data-id="element-52">
      <div className={`flex items-center justify-center w-10 h-10 rounded-lg text-lg shadow-sm ${badgeClass}`} data-id="element-53">
        00
      </div>
      <span className={`text-xl font-bold ${separatorClass}`} data-id="element-54">:</span>
      <div className={`flex items-center justify-center w-10 h-10 rounded-lg text-lg shadow-sm ${badgeClass}`} data-id="element-55">
        {minutes}
      </div>
      <span className={`text-xl font-bold ${separatorClass}`} data-id="element-56">:</span>
      <div className={`flex items-center justify-center w-10 h-10 rounded-lg text-lg shadow-sm ${badgeClass}`} data-id="element-57">
        {seconds}
      </div>
    </div>;
}